import router from '@/router';
import SCookieBanner from '@/components/stemdo-components/s-cookie-banner/SCookieBanner.vue';

export default {
  components: { SCookieBanner },
  setup() {
    const goToLoginPage = () => {
      router.push('/login');
    };

    return { goToLoginPage };
  }
};
